// Module
var code = "<docker-service-tasks-datatable\r\n  ng-if=\"tasks.length > 0\"\r\n  dataset=\"tasks\"\r\n  is-slot-column-visible=\"service.Mode !== 'global'\"\r\n  service-name=\"service.Name\"\r\n></docker-service-tasks-datatable>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/services/edit/includes/tasks.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;